import { useContext } from 'react';

import { User } from '../types';

import UserContext from './context';

const useUser = (): User => useContext(UserContext);

export default useUser;
